import { ServiceDeliveryRepository } from "@/modules/revenue/domain/ServiceDeliveryRepository";

type AccessPermission = {
  view_invoices: boolean;
  view_banks: boolean;
  view_e_invoice: boolean;
  view_gestor: boolean;
  view_working_hours: boolean;
};

export class GetAccessViewAvailabilityQuery {
  constructor(
    private readonly sd_repository: ServiceDeliveryRepository,
    private readonly screen_data: { [key: string]: any }
  ) {}

  async execute(userRole) {
    const accessMap: { [key: string]: string } = {
      view_invoices: 'documents',
      view_banks: 'banks',
      view_e_invoice: 'facturae_credits',
      view_gestor: 'credits',
      view_working_hours: 'working_hours',
    };

    await Promise.all(
      Object.keys(accessMap).map(async (perm) => {
    
        const ct_kind = accessMap[perm];

        const sds = await this.sd_repository.find_by_criteria( [[['service.kind', ct_kind, '==']]], 'start_date', 'desc', 1);

        const current = this.screen_data[perm];
        if (!current) {
            throw new Error(`screen_data missing key: ${perm}`);
        }

        if (userRole === 'customer' && (ct_kind === 'facturae_credits' || ct_kind === 'working_hours')) {
          current.show = true;
          current.error = false;
          return;
        }

        if (!sds.length) {
          current.show = false;
          current.error = false;
          return;
        }

        current.show = true;
        const sd = sds[0];
        const currentUsers = sd.users_num || 0;
        const maxUsers = (sd.service.limit_users || 0) + (sd.paid_extra_users || 0);
        current.error = currentUsers >= maxUsers;
      })
    );
  }
}
